// function stepForm() {
//     const steps = document.querySelectorAll('.membership-registration__step');
//     const prevButton = document.querySelector('.membership-registration__prev');
//     const nextButton = document.querySelector('.membership-registration__next');
//     const form = document.querySelector('.membership-registration__form');
//     const stepNumbers = document.querySelectorAll('.membership-registration__step-number');
//     const buttonWrapper = document.querySelector('.membership-registration__buttons');
//     const submitButton = document.querySelector('.membership-registration__submit');
//     const progress = document.querySelector('.membership-registration__progress-suscess');

//     form.addEventListener('submit', e => e.preventDefault());

//     let formStep = 0;

//     prevButton.addEventListener('click', () => {
//         formStep--;

//         stepNumbers[formStep + 1].classList.remove('active-number');

//         updateFormSteps();
//     });

//     nextButton.addEventListener('click', () => {
//         formStep++;

//         updateFormSteps();
//     });

//     function updateFormSteps() {
//         steps.forEach((step) => {
//             step.classList.contains('active') && step.classList.remove('active');
//         })

//         steps[formStep].classList.add('active');
//         stepNumbers[formStep].classList.add('active-number');

//         if(formStep === 0){
//             prevButton.style.display = 'none';
//             buttonWrapper.classList.add('one-button');
//         } else {
//             prevButton.style.display = 'block';
//             buttonWrapper.classList.remove('one-button');
//         }

//         if(formStep === steps.length -1){
//             nextButton.style.display = 'none';
//             submitButton.classList.add('active');
//         } else {
//             nextButton.style.display = 'block';
//             submitButton.classList.remove('active');
//         }

//         const activeNumbers = document.querySelectorAll('.active-number');
//         const percent = (( activeNumbers.length -1 ) / (stepNumbers.length -1)) * 100 + '%';

//         progress.style.width = percent;

//     };

//     updateFormSteps();
// }

// stepForm();

setTimeout(() => {
	let breedLable = document.querySelector('.breed-checkbox-label');
	let breedList = document.querySelector('.membership-registration__breed-list-wrapper');
  let checkBox = document.querySelector('input[name="select_dog_breed"]');

	breedLable.addEventListener("click", function (e) {
			// e.preventDefault();
			// breedList.classList.toggle("active");
			// breedLable.classList.toggle("active");

if (checkBox.checked == true){
    breedList.classList.add("active");
	breedLable.classList.add("active");
  } else {
    breedList.classList.remove("active");
    breedLable.classList.remove("active");
  }
      
	});
}, 3000);
